import React from 'react';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Paper,
} from '@mui/material';

const RM_fifth = () => {
  return (
    <Box
      sx={{
        width: '95%',
        py: 2,
        display: 'flex',
        gap: 2,
        boxSizing: 'border-box',
      }}
    >
      {/* Principles Overview */}
      <Box
        sx={{
          flex: 1,
          p: 2,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 2,
        }}
      >
        <Typography variant="h6" fontWeight={600} sx={{ color: '#242424' }} >
          Research Integrity
        </Typography>

        <Typography variant="body2" mt={1}>
          Our research is built on principles that ensure integrity and actionable outcomes:
        </Typography>
      </Box>

      {/* Principles List */}
      <Box
        sx={{
          flex: 1,
          p: 2,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 2,
        }}
      >
        <List dense disablePadding>
          {[
            'Accuracy over assumptions',
            'Transparent and verifiable sources',
            'Zero conflicts of interest',
            'Confidentiality and client-first ethics',
            'Customized, sector-specific insights',
          ].map((text, idx) => (
            <ListItem key={idx} disableGutters>
              <ListItemText primary={`• ${text}`} />
            </ListItem>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default RM_fifth;
